import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styled from 'styled-components'

export const Card = styled.article`
  display: flex;
  flex-direction: column;
  background-color: var(--white);
  border-radius: 0.5rem;
  overflow: hidden;
  height: 100%;
  box-shadow:
    0px var(--Elevation1OffsetY1, 1px) var(--Elevation1Radius1, 2px) 0px var(--shadow-smooth),
    0px var(--Elevation1OffsetY2, 2px) var(--Elevation1Radius2, 4px) 0px var(--shadow-smooth);
`

export const CardImage = styled.img`
  width: 100%;
  height: 140px;
  object-fit: cover;
  display: block;
  pointer-events: none;
`

export const CardImageButton = styled.button`
  display: block;
  width: 100%;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  line-height: 0;

  &:focus-visible {
    outline: 2px solid var(--primary);
    outline-offset: 2px;
  }
`

export const CardBody = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 1rem;
  gap: 0.75rem;
`

export const CardTitle = styled.h3`
  font-size: 1rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0;
  line-height: 1.3;
`

export const CardDescription = styled.p`
  font-size: 0.8125rem;
  font-weight: 400;
  color: var(--text-secondary);
  margin: 0;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  flex: 1;
`

export const CapacityRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.375rem;
  font-size: 0.8125rem;
  font-weight: 400;
  color: var(--grey);
`

export const CapacityIcon = styled(FontAwesomeIcon)`
  font-size: 0.875rem;
  color: var(--orange-medium);
`

export const SelectButton = styled.button<{ $isSelected: boolean; $isDisabled?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.375rem;
  width: 100%;
  padding: 0.5rem 1rem;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 700;
  line-height: 1rem;
  cursor: ${({ $isDisabled }) => ($isDisabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ $isDisabled }) => ($isDisabled ? 0.5 : 1)};
  margin-top: auto;
  box-shadow: none;

  ${({ $isSelected }) =>
    $isSelected
      ? `
    border: 1px solid var(--orange-medium);
    background-color: var(--orange-medium);
    color: var(--white);

    &:hover {
      border-color: var(--orange-medium);
      background-color: var(--orange-medium);
      color: var(--white);
    }
  `
      : `
    border: 1px solid var(--orange-medium);
    background-color: var(--white);
    color: var(--orange-medium);

    &:hover {
      border-color: var(--orange-medium);
      background-color: var(--white);
      color: var(--orange-medium);
    }
  `}

  &:focus,
  &:active {
    outline: none;
    box-shadow: none;
  }
`

export const SelectButtonIcon = styled(FontAwesomeIcon)`
  font-size: 0.75rem;
  color: inherit;
`
